import axios from 'axios'
import { push } from 'connected-react-router'
import endpoints from 'services/endpoints'
import _ from 'lodash'
import { showErrorMessage } from 'services/handleErrors'

import {
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_LOADING,
  USER_LOGIN_RESET,
  USER_LOGIN_ERROR_RESET,
  GET_PROFILE_DATA_SUCCESS,
  GET_ACCOUNT_BALANCE_SUCCESS,
  GET_ACCOUNT_BALANCE_LOADING,
  GET_CURRENT_GOAL_DATA_SUCCESS,
  GET_ACCOUNT_BALANCE_ERROR
} from './actionTypes'

export const logInReset = () => dispatch => {
  axios.post(endpoints.logout)
  .catch((err) => console.error(err))

  setTimeout(() => {
    dispatch({ type: USER_LOGIN_RESET })
    dispatch(push('/login'))
  }, 100)
}

export const errorReset = () => ({ type: USER_LOGIN_ERROR_RESET })

export const logIn = (params, enterMethod) => dispatch => {
  dispatch({ type: USER_LOGIN_LOADING })

  axios
    .post(endpoints.login, { ...params })
    .then(response => {
      const {
        data: { accessToken, refreshToken },
      } = response

      if (!accessToken) throw new Error(`page.login.auth-wrong-pass-or-${enterMethod}-text`)

      dispatch({ type: USER_LOGIN_SUCCESS, data: { accessToken, refreshToken } })
      dispatch(getProfileData())
      dispatch(getAccountBalance())
      dispatch(getCurrentGoal())
    })
    .then(() => dispatch(push('/')))
    .catch(error => {
      console.log(error)
      if (error.response && error.response.status === 401) {
        return dispatch({
          type: USER_LOGIN_FAIL,
          error: `page.login.auth-wrong-pass-or-${enterMethod}-text`,
        })
      }

      return dispatch({ type: USER_LOGIN_FAIL, error: 'page.login.auth-error-text' })
    })
}

export const getProfileData = () => dispatch => {
  return axios
    .post(endpoints.getMe)
    .then(res => {
      const data = { ...res.data.user }
      if (data.certifiedDiagnostician !== true) {
        data.certifiedDiagnostician = false
      }

      dispatch({ type: GET_PROFILE_DATA_SUCCESS, data })

      window.Sentry.configureScope(scope => scope.setUser({ id: _.get(res, 'data.user.id') }))
    })
    .catch(err => showErrorMessage(err))
}

export const getCurrentGoal = () => dispatch => {
  return axios
    .post(endpoints.getCurrentGoal)
    .then(res => {
      dispatch({ type: GET_CURRENT_GOAL_DATA_SUCCESS, data: { currentGoal: res.data.goal } })
    })
    .catch(err => {
      if (err.response.status === 404) {
        dispatch({ type: GET_CURRENT_GOAL_DATA_SUCCESS, data: { currentGoal: null } })
      }

      showErrorMessage(err)
    })
}

export const getAccountBalance = () => dispatch => {
  dispatch({ type: GET_ACCOUNT_BALANCE_LOADING })

  return axios
    .post(endpoints.getAccountBalance, { currencyId: 1 })
    .then(({ data }) => dispatch({ type: GET_ACCOUNT_BALANCE_SUCCESS, data }))
    .catch((err) => {
      dispatch({ type: GET_ACCOUNT_BALANCE_ERROR })
      showErrorMessage(err)
    })
}

// USES IN src/pages/create-goal/StepSetGoal
export const setCurrentGoal = currentGoal => dispatch => {
  dispatch({ type: GET_CURRENT_GOAL_DATA_SUCCESS, data: { currentGoal } })
}
